import { useEffect, useState, FC } from "react";
import { SlugProps } from "@/features/challenge/types/props/SingleChallengeProps";
import { useInView } from "react-intersection-observer";
import { LeaderboardUI } from "./Leaderboard.ui";
import { useLeaderboardData } from "../../helperFunctions/useLeaderboardData";

export const Leaderboard: FC<
  SlugProps & {
    color?: string;
    game: string;
    isPreview?: boolean;
    status?: string;
    client?: string;
    maxItems?: number;
  }
> = ({
  slug,
  game,
  isPreview = false,
  status,
  client,
  maxItems,
}): JSX.Element => {
  const [updatingTimer, setUpdatingTimer] = useState<number>();
  const [isUpdated, setIsUpdated] = useState<boolean>(false);
  const [selectedFilterType, setPropsFilters] = useState<
    "ALL" | "FRIENDS" | "FOLLOWING"
  >("ALL");

  const [refOfAll, inViewOfAll] = useInView();

  const updateLeaderboardHandler = (isTimeOut: boolean) => {
    if (isTimeOut) {
      setUpdatingTimer(undefined);
      setIsUpdated(true);
    }
  };

  const filterKey = selectedFilterType;

  const {
    leaderboardLiveData,
    currentUserDataInThisChallenge,
    loading,
    fetchLiveLeaderboard,
  } = useLeaderboardData({
    filterKey,
    slug,
    client,
    selectedFilterType,
    status,
    inViewOfAll,
  });

  // if user is participating then userChallengeData will not be undefined
  const isUserParticipated = !!currentUserDataInThisChallenge;

  useEffect(() => {
    const fetchData = async () => {
      if (selectedFilterType === "ALL") {
        if (!leaderboardLiveData) {
          await fetchLiveLeaderboard();
        }
      }
    };

    fetchData();
  }, [slug, selectedFilterType]);

  return (
    <LeaderboardUI
      selectedFilterType={selectedFilterType}
      setPropsFilters={setPropsFilters}
      updatingTimer={updatingTimer}
      updateLeaderboardHandler={updateLeaderboardHandler}
      currentUserInThisChallenge={currentUserDataInThisChallenge}
      isPreview={isPreview}
      leaderboardData={leaderboardLiveData}
      loading={loading}
      game={game}
      isUserParticipated={isUserParticipated}
      maxItems={maxItems}
    />
  );
};
